// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { safeReturnDestination } from '@application/common/helpers/mail-links';
import { logout } from '@application/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { Box, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
const ProtectedRoute = ({ children, requiredRoles }) => {
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { currentUser } = useAppSelector((state) => state.auth);
    const isMdUp = useState(theme.breakpoints.up('md'));
    useEffect(() => {
        if (!currentUser) {
            // If no user is logged in, redirect to login
            navigate('/login', { replace: true, state: { returnTo: safeReturnDestination(location.pathname + location.search + location.hash) } });
            return;
        }
        const userHasRequiredRole = currentUser && requiredRoles.includes(currentUser.role);
        if (!userHasRequiredRole) {
            // If user does not have the required role, log out and redirect to login
            dispatch(logout());
            navigate('/login', { replace: true, state: { returnTo: safeReturnDestination(location.pathname + location.search + location.hash) } });
        }
        else if (location.pathname === '/my-profile-account-information' && ['Admin', 'SuperAdmin'].includes(currentUser.role)) {
            navigate('/home');
        }
    }, [currentUser, requiredRoles, dispatch, location, navigate]);
    if (!currentUser || !requiredRoles.includes(currentUser.role))
        return null;
    // Render the child routes if all checks pass
    return (_jsx(Box, { px: 3, pb: 2, pt: 7, mt: '40px', width: '100%', minHeight: 'calc(100svh - 40px)', sx: { background: theme.palette.background.neutral }, children: _jsx(Outlet, {}) }));
};
export default ProtectedRoute;
